module.exports = __webpack_public_path__ + "static/img/12.454e341.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/eng/12.png
// module id = 8u+e
// module chunks = 0